import { I4BCellType, I4BColumnConfiguration } from './configurations/i4b-column-configuration';
import { getDefaultColumnsByConcept } from './default-columns.registry';
import { ArrayOfObjectColumn } from './definitions';
import { I4BBasicColumn } from './definitions/i4b-basic.column';
import { I4BColumn } from './definitions/i4b-column';
import { I4BProductsButtonColumn } from './definitions/i4b-products-button.column';
import { I4bCellConcept } from './enums';
import { ProductsGridData } from './models';
import { HeaderType, I4BColumnHeader } from './models/i4b-column-header.model';
import { I4BGridOptions } from './models/i4b-grid-options.model';
import { I4BGrid } from './models/i4b-grid.model';
import { I4BColumnOptions } from './options/i4b-column-options';

export const GET_DEFAULT_PRODUCTS_COLUMNS_FOR_PRODUCTS_VIEW = (): I4BColumn<I4BColumnHeader, I4BColumnConfiguration, I4BColumnOptions>[] => [
  new I4BBasicColumn(
    { displayName: 'PRODUCT ID', type: HeaderType.BASIC },
    {
      id: 'identifier',
      translationKey: 'I18N_ADMIN.PRODUCT_CATALOGS.PRODUCT_ID',
      width: 150,
      isDefault: true,
      sortProperty: 'identifier',
      concept: I4bCellConcept.PRODUCTS,
      cell: { type: I4BCellType.BASIC }
    },
    { order: 0 }
  ),

  new I4BBasicColumn(
    { displayName: 'NAME', type: HeaderType.BASIC },
    {
      id: 'name',
      translationKey: 'IOT_DICTIONARY.NAME',
      width: 150,
      isDefault: true,
      sortProperty: 'name',
      concept: I4bCellConcept.PRODUCTS,
      cell: { type: I4BCellType.BASIC }
    },
    { order: 1 }
  ),

  new I4BBasicColumn(
    { displayName: 'CATALOG NAME', type: HeaderType.BASIC },
    {
      id: 'catalog.name',
      translationKey: 'I18N_ADMIN.PRODUCT_CATALOGS.CATALOG_NAME',
      width: 150,
      isDefault: true,
      sortProperty: 'catalog.name',
      concept: I4bCellConcept.PRODUCTS,
      cell: { type: I4BCellType.BASIC }
    },
    { order: 2 }
  ),

  new ArrayOfObjectColumn(
    { displayName: 'ATTACHED ENTITIES', type: HeaderType.BASIC },
    {
      id: 'catalog.entities',
      translationKey: 'MASTER_VIEW_ENGINE.TABLE.HEADER_NAME.ATTACHED_ENTITIES',
      width: 200,
      isDefault: true,
      concept: I4bCellConcept.PRODUCTS,
      cell: {
        type: I4BCellType.ARRAY_OF_OBJECTS,
        options: { attributes: ['name'] }
      }
    },
    { order: 3, sortable: false }
  )
];

export class DefaultProductsGrid implements I4BGrid<I4BGridOptions, ProductsGridData> {
  masterview = 'products';
  isDefault = true;
  isUserDefault = true;
  isAppDefault = true;
  name = 'products';
  userId = '';
  data: ProductsGridData = {
    response: {
      data: [],
      pagination: null
    }
  };
  gridOptions: I4BGridOptions = {
    pageSize: 100,
    multipleSelection: false,
    autoRefresh: { enabled: false },
    buttonColumn: { enabled: true, className: new I4BProductsButtonColumn() },
    gridSort: []
  };
  columns: I4BColumn<I4BColumnHeader, I4BColumnConfiguration, I4BColumnOptions>[] = [...getDefaultColumnsByConcept(this.masterview)];
}
